import { useEffect, useState } from "react";
import { isBrowser } from "../next-utils";
function getWindowDimensions() {
    if (!isBrowser || !window) return;
    const { innerWidth: width , innerHeight: height  } = window;
    return {
        width,
        height
    };
}
export default function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState({
        width: 0,
        height: 0
    });
    const isMobile = windowDimensions.width < 744;
    const isTablet = windowDimensions.width >= 744 && windowDimensions.width < 1200;
    const isDesktop = windowDimensions.width >= 1200;
    // device 판정: mobile(< 744) → tablet(744~1200) → pc(>= 1201)
    const device = isMobile ? "mobile" : isTablet ? "tablet" : "pc";
    useEffect(()=>{
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }
        if (isBrowser) {
            handleResize() // call once to set initial dimensions
            ;
            window.addEventListener("resize", handleResize);
        }
        return ()=>{
            if (isBrowser) {
                window.removeEventListener("resize", handleResize);
            }
        };
    }, []);
    return {
        ...windowDimensions,
        isMobile,
        isTablet,
        isDesktop,
        device
    };
}
